import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { ConfirmService } from '../confirm.service'
import { IsDirty } from './is-dirty.interface'

@Injectable()
export class IsDirtyService {
  constructor(protected confirmService: ConfirmService) {}

  canDeactivate(component: IsDirty): boolean | Observable<boolean> {
    const isDirty = component?.isDirty()
    if (isDirty) {
      return this.confirmService.confirm({
        message: 'You have unsaved changed, are you sure you want to leave?',
      })
    } else {
      return true
    }
  }
}
